import React, { useState, useEffect } from "react";
import { apiRequest } from "../apiService/allApi";
import { useNavigate, Link } from "react-router-dom"; // Assuming React Router is used for navigation
import Swal from "sweetalert2";
import axios from "axios";

const Checkout = () => {
  const [savedAddress, setSavedAddress] = useState(null);
  const [selectedAddress, setSelectedAddress] = useState(null);
  const [showAddressForm, setShowAddressForm] = useState(true);
  const [loading, setLoading] = useState(false);
  const [cartItems, setCartItems] = useState([]);
  const [selectedPayment, setSelectedPayment] = useState("upi");
 


  // Address form state
  const [addressForm, setAddressForm] = useState({
    firstName: "",
    lastName: "",
    street: "",
    apartment: "",
    city: "",
    state: "",
    country: "",
    postCode: "",
    phone: "",
    email: "",
    notes: "",
  });
  const [saveAddress, setSaveAddress] = useState(false);
  const navigate = useNavigate();
  const profileData = JSON.parse(localStorage.getItem("profiledata")) ?? null;
  var orderId;
  // Validation functions
  const validateCardNumber = (number) => {
    const cleaned = number.replace(/\s+/g, "").replace(/[^0-9]/gi, "");
    if (cleaned.length < 13 || cleaned.length > 19)
      return "Card number must be 13-19 digits.";
    // Luhn algorithm
    let sum = 0;
    let shouldDouble = false;
    for (let i = cleaned.length - 1; i >= 0; i--) {
      let digit = parseInt(cleaned.charAt(i), 10);
      if (shouldDouble) {
        digit *= 2;
        if (digit > 9) digit -= 9;
      }
      sum += digit;
      shouldDouble = !shouldDouble;
    }
    if (sum % 10 !== 0) return "Invalid card number.";
    return "";
  };

  const validateExpiry = (expiry) => {
    const match = expiry.match(/^(\d{2})\/(\d{2})$/);
    if (!match) return "Expiry must be in MM/YY format.";
    const month = parseInt(match[1], 10);
    const year = parseInt(match[2], 10) + 2000;
    if (month < 1 || month > 12) return "Invalid month.";
    const now = new Date();
    const expiryDate = new Date(year, month - 1);
    if (expiryDate <= now) return "Card has expired.";
    return "";
  };

  const validateCvv = (cvv) => {
    const cleaned = cvv.replace(/[^0-9]/gi, "");
    if (cleaned.length < 3 || cleaned.length > 4)
      return "CVV must be 3-4 digits.";
    return "";
  };

  const validateName = (name) => {
    if (!name.trim()) return "Name is required.";
    if (!/^[a-zA-Z\s]+$/.test(name))
      return "Name can only contain letters and spaces.";
    return "";
  };

  const handleCardChange = (e) => {
    const { name, value } = e.target;
    setCardDetails((prev) => ({
      ...prev,
      [name]: value,
    }));

    let error = "";
    if (name === "cardNumber") error = validateCardNumber(value);
    else if (name === "expiry") error = validateExpiry(value);
    else if (name === "cvv") error = validateCvv(value);
    else if (name === "name") error = validateName(value);

    setCardErrors((prev) => ({
      ...prev,
      [name]: error,
    }));
  };

  // useEffect(() => {
  //   fetchSavedAddress();
  // }, []);

  useEffect(() => {
    const cart = JSON.parse(sessionStorage.getItem("cart")) || [];
    setCartItems(cart);
  }, []);
  const subTotal = cartItems.reduce(
    (total, item) => total + item.price * item.qty,
    0,
  );
  const deliveryFee = 100;
const gstRate = 0.05; // 5% GST
const gstAmount = subTotal * gstRate;

const totalAmount = subTotal + gstAmount + deliveryFee;

  // const fetchSavedAddress = async () => {
  //   setLoading(true);
  //   const token = localStorage.getItem("token");
  //   const headers = {
  //     Authorization: `Bearer ${token}`,
  //   };
  //   try {
  //     const res = await apiRequest(
  //       `api/customer/shipping/address/${profileData?._id}`,
  //       "GET",
  //       null,
  //       headers,
  //     );
  //     if (res.data) {
  //       setSavedAddress(res.data?.shippingAddress);
  //     }
  //   } catch (e) {
  //     console.log(e);
  //   } finally {
  //     setLoading(false);
  //   }
  // };

  // const handleSelectAddress = (address) => {
  //   console.log(address);
  //   setSelectedAddress(address);

  //   setAddressForm({
  //     firstName: address.firstName || "",
  //     lastName: address.lastName || "",
  //     street: address.street || "",
  //     apartment: address.apartment || "",
  //     city: address.city || "",
  //     state: address.state || "",
  //     country: address.country || "",
  //     postCode: address.postCode || "",
  //     phone: address.phone || "",
  //     email: address.email || "",
  //     notes: address.notes || "",
  //   });

  //   // setShowAddressForm(false);
  // };

  // const handleUseNewAddress = () => {
  //   setSelectedAddress(null);
  //   setShowAddressForm(true);
  // };

  const handleAddressChange = (e) => {
    const { name, value } = e.target;
    setAddressForm((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handlePlaceOrder = async () => {
    const hasSelectedAddress = selectedAddress !== null;
    const hasFormAddress =
      addressForm.firstName &&
      addressForm.lastName &&
      addressForm.street &&
      addressForm.city &&
      addressForm.stateCountry &&
      addressForm.postCode &&
      addressForm.phone &&
      addressForm.email;

    if (!hasSelectedAddress && !hasFormAddress) {
      Swal.fire({
        title: "info !",
        text: "Please select a saved address or fill in the address form before placing the order.",
        icon: "info",
      });
      return;
    }

    // Validate payment
    // if (selectedPayment === "upi" && !selectedUPIApp) {
    //   alert("Please select a UPI app.");
    //   return;
    // }
    // if (selectedPayment === "debit") {
    //   if (
    //     !cardDetails.cardNumber ||
    //     !cardDetails.expiry ||
    //     !cardDetails.cvv ||
    //     !cardDetails.name
    //   ) {
    //     alert("Please fill in all card details.");
    //     return;
    //   }
    //   // Check for validation errors
    //   if (
    //     cardErrors.cardNumber ||
    //     cardErrors.expiry ||
    //     cardErrors.cvv ||
    //     cardErrors.name
    //   ) {
    //     alert("Please correct the card details errors.");
    //     return;
    //   }
    // }

    // Build address data
    const addressData = selectedAddress || {
      name: `${addressForm.firstName} ${addressForm.lastName}`,
      street: addressForm.street,
      apartment: addressForm.apartment,
      city: addressForm.city,
      state: addressForm.state,
      pincode: addressForm.postCode,
      mobile: addressForm.phone,
      email: addressForm.email,
    };

    // Build cart data
    const cartData = cartItems.map((item) => ({
      prices: {
        price: item.price,
        qty: item.qty,
        originalPrice: item.price, // assuming no originalPrice, use price
        discount: 0, // static
        image: item.image,
        name: item.name,
      },
    }));

    // Calculate subTotal
    // const subTotal = cartItems.reduce(
    //   (total, item) => total + item.price * item.qty,
    //   0,
    // );
    let delivery = 100;

    // Build orderData
    const fullAddress = `${addressData.street}${addressData.apartment ? ", " + addressData.apartment : ""}`;
   const orderData = {
  user_info: {
    name: profileData?.name || addressData.name,
    contact: profileData?.contact || addressData.mobile,
    email: profileData?.email || addressData.email,
    address: fullAddress,
    city: addressData.city,
    state: addressData.state,
    country: addressForm.country || "India",
    zipCode: addressData.pincode,
  },

  cart: cartData,
  discount: 0,

  paymentMethod:
    selectedPayment === "cod"
      ? "Cash"
      : selectedPayment === "debit"
      ? "Debit Card"
      : "UPI",

  order_id: orderId,
  shippingCost: deliveryFee,
  shippingOption: "UPS",
  status: "Pending",
  paymentStatus: "Pending",

  subTotal: subTotal,
  gst: gstAmount,          // ✅ ADD THIS
  total: totalAmount,      // ✅ ADD THIS

  address: fullAddress,
  shippingAddress: fullAddress,
  city: addressData.city,
  contact: addressData.mobile,
  country: addressForm.country || "India",
  email: addressData.email,
  name: addressData.name,
  zipCode: addressData.pincode,
};


    try {
      const token = localStorage.getItem("token");
      const headers = {
        Authorization: `Bearer ${token}`,
      };
      const res = await apiRequest("api/order/add", "POST", orderData, headers);
      if (res.status === 200 || res.status === 201) {
        // Save address if checkbox is checked
        if (saveAddress && !selectedAddress) {
          try {
            const addressToSave = {
              name: `${addressForm.firstName} ${addressForm.lastName}`,
              street: addressForm.street,
              city: addressForm.city,
              state:
                addressForm.stateCountry.split(",")[0]?.trim() ||
                addressForm.stateCountry,
              pincode: addressForm.postCode,
              mobile: addressForm.phone,
            };
            await apiRequest(
              `api/customer/shipping/address/${profileData?._id}`,
              "POST",
              addressToSave,
              headers,
            );
          } catch (saveError) {
            console.log("Error saving address:", saveError);
          }
        }

        // Clear cart after successful order
        sessionStorage.removeItem("cart");
        window.dispatchEvent(new Event("cartUpdated"));
        // Show SweetAlert success message
        Swal.fire({
          title: "Order Placed Successfully!",
          text: "Your order has been placed and will be processed soon.",
          icon: "success",
          timer: 3000,
        });
        navigate("/"); // Navigate to home page after alert
      } else {
        console.error(
          "Order placement failed with status:",
          res.status,
          res.data,
        );
      }
    } catch (error) {
      console.error("Order placement error:", error);
      if (error.response && error.response.status === 401) {
        // Optionally, clear localStorage and navigate to login
        localStorage.removeItem("token");
        localStorage.removeItem("profiledata");
        navigate("/login"); // Assuming login route
      } else {
        Swal.fire({
          title: "error !",
          text: "Order placement failed.",
          icon: "error",
        });
        return;
      }
    }
  };

  const razorpay = async (e) => {
    e.preventDefault();
    const hasSelectedAddress = selectedAddress !== null;
    const hasFormAddress =
      addressForm.firstName &&
      addressForm.lastName &&
      addressForm.street &&
      addressForm.city &&
      addressForm.stateCountry &&
      addressForm.postCode &&
      addressForm.phone &&
      addressForm.email;

    if (!hasSelectedAddress && !hasFormAddress) {
      Swal.fire({
        title: "info !",
        text: "Please select a saved address or fill in the address form before placing the order.",
        icon: "info",
      });
      return;
    }

    let delivery = 100;

let finalAmount = totalAmount;

    const requestData = {
      amount: finalAmount,
    };

    try {
      const token = localStorage.getItem("token");
      const headers = {
        Authorization: `Bearer ${token}`,
      };

      const response = await apiRequest(
        "api/razorpay/create-order",
        "POST",
        requestData,
        headers,
      );
      if (response.data.success) {
        let resdata = response.data;
        const options = {
          key: resdata?.keyId,
          amount: resdata?.amount,
          currency: resdata?.currency,
          name: "TGVL",
          description: "online payment",
          order_id: resdata?.orderId,

          handler: function (response) {
            // console.log(response, "hhhhhh");
            orderId = response.razorpay_order_id;
            handlePlaceOrder();
          },
          prefill: {
            name: addressForm.firstName,
            email: addressForm.email,
            contact: addressForm.phone, // auto fill phone
          },

          method: {
            upi: true,
            card: true,
            netbanking: true,
            wallet: true,
          },

          theme: {
            color: "#3399cc",
          },
        };

        const razor = new window.Razorpay(options);
        razor.open();
      }
    } catch (e) {
      console.log(e);

      Swal.fire({
        title: "login !",
        text: "Your token expired please login again.",
        icon: "error",
      });
      localStorage.clear();
      navigate("/login"); // Assuming login route
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <div className="cover-bg-img">
        <div className="dz-bnr-inr-entry">
          <h1>Checkout</h1>
          <nav aria-label="breadcrumb" className="breadcrumb-row">
            <ul className="breadcrumb">
              <li className="breadcrumb-item">
                <Link to="/">Home</Link>
              </li>
              <li className="breadcrumb-item">CheckOut</li>
            </ul>
          </nav>
        </div>
      </div>
      <section className="checkout py-80">
        <div className="container container-lg">
          <div className="row">
            {/* LEFT FORM */}
            <div className="col-xl-8 col-lg-7">
              {savedAddress && (
                <div className="mb-4">
                  <h6 className="text-lg mb-3">Select Address</h6>
                  <div className="border border-gray-100 rounded-8 p-3 mb-3">
                    <input
                      type="radio"
                      name="address"
                      id="savedAddress"
                      onChange={() => handleSelectAddress(savedAddress)}
                      checked={selectedAddress === savedAddress}
                    />
                    <label htmlFor="savedAddress" className="ms-2">
                      <strong>{savedAddress?.name}</strong>
                      <br />
                      {savedAddress?.street}, {savedAddress?.city},{" "}
                      {savedAddress?.state} - {savedAddress?.pincode}
                      <br />
                      Mobile: {savedAddress?.mobile}
                    </label>
                  </div>
                  {/* <button
                    type="button"
                    className="add-cart-btn w-auto mt-3 mt-sm-0"
                    onClick={handleUseNewAddress}
                  >
                    Use New Address
                  </button> */}
                </div>
              )}
              {showAddressForm && (
                <form className="pe-xl-5">
                  <div className="row gy-3">
                    <div className="col-sm-6 col-xs-6">
                      <input
                        type="text"
                        name="firstName"
                        className="common-input border-gray-100"
                        placeholder="First Name"
                        value={addressForm.firstName}
                        onChange={handleAddressChange}
                        required
                      />
                    </div>

                    <div className="col-sm-6 col-xs-6">
                      <input
                        type="text"
                        name="lastName"
                        className="common-input border-gray-100"
                        placeholder="Last Name"
                        value={addressForm.lastName}
                        onChange={handleAddressChange}
                        required
                      />
                    </div>

                    <div className="col-12">
                      <input
                        type="text"
                        name="street"
                        className="common-input border-gray-100"
                        placeholder="House number and street name"
                        value={addressForm.street}
                        onChange={handleAddressChange}
                        required
                      />
                    </div>

                    <div className="col-12">
                      <input
                        type="text"
                        name="apartment"
                        className="common-input border-gray-100"
                        placeholder="Apartment, suite, unit, etc. (Optional)"
                        value={addressForm.apartment}
                        onChange={handleAddressChange}
                      />
                    </div>

                    <div className="col-12">
                      <input
                        type="text"
                        name="city"
                        className="common-input border-gray-100"
                        placeholder="City"
                        value={addressForm.city}
                        onChange={handleAddressChange}
                        required
                      />
                    </div>

                    <div className="col-12">
                      <input
                        type="text"
                        name="stateCountry"
                        className="common-input border-gray-100"
                        placeholder="State, Country"
                        value={addressForm.stateCountry}
                        onChange={handleAddressChange}
                        required
                      />
                    </div>

                    <div className="col-12">
                      <input
                        type="text"
                        name="postCode"
                        className="common-input border-gray-100"
                        placeholder="Post Code"
                        value={addressForm.postCode}
                        onChange={handleAddressChange}
                        required
                      />
                    </div>

                    <div className="col-12">
                      <input
                        type="number"
                        name="phone"
                        className="common-input border-gray-100"
                        placeholder="Phone"
                        value={addressForm.phone}
                        onChange={handleAddressChange}
                        required
                      />
                    </div>

                    <div className="col-12">
                      <input
                        type="email"
                        name="email"
                        className="common-input border-gray-100"
                        placeholder="Email Address"
                        value={addressForm.email}
                        onChange={handleAddressChange}
                        required
                      />
                    </div>

                    {/* <div className="col-12">
                      <label className="d-flex align-items-center">
                        <input
                          type="checkbox"
                          checked={saveAddress}
                          onChange={(e) => setSaveAddress(e.target.checked)}
                          className="me-2"
                        />
                        Save this address for future orders
                      </label>
                    </div> */}

                    {/* <div className="col-12">
                      <div className="my-40">
                        <h6 className="text-lg mb-24">
                          Additional Information
                        </h6>
                        <input
                          type="text"
                          name="notes"
                          className="common-input border-gray-100"
                          placeholder="Notes about your order, e.g. special notes for delivery."
                          value={addressForm.notes}
                          onChange={handleAddressChange}
                        />
                      </div>
                    </div> */}
                  </div>
                </form>
              )}
            </div>

            {/* RIGHT SIDEBAR */}
            <div className="col-xl-4 col-lg-5">
              <div className="checkout-sidebar">
                <div className="bg-color-three rounded-8 p-24 text-center">
                  <span className="text-gray-900 text-xl fw-semibold">
                    Your Orders
                  </span>
                </div>

                <div className="border border-gray-100 rounded-8 px-24 py-40 mt-24">
                  <div className="mb-32 pb-32 border-bottom border-gray-100 d-flex justify-content-between">
                    <span className="fw-medium text-xl">Product</span>
                    <span className="fw-medium text-xl">Subtotal</span>
                  </div>

                  {cartItems.map((item) => (
                    <div
                      key={item._id}
                      className="d-flex justify-content-between mb-32"
                    >
                      <div className="d-flex gap-12">
                        <span className="w-144">{item.name}</span>
                        <span>×</span>
                        <span className="fw-semibold">{item.qty}</span>
                      </div>
                      <span className="fw-bold">₹{item.price * item.qty}</span>
                    </div>
                  ))}
                  <div className="d-flex align-items-center">
                    <input
                      type="text"
                      class="common-input border-gray-100"
                      placeholder="Coupon"
                      fdprocessedid="lxwrco"
                    ></input>

                    <button className="add-cart-btn bg-success w-auto mt-3 mt-sm-0 ms-3">
                      Check
                    </button>
                  </div>

                  <div className="border-top pt-30 mt-30">
                    <div className="mb-20 d-flex justify-content-between">
                      <span className="fw-semibold text-xl">Subtotal</span>
                      <span className="fw-bold text-dark">₹{subTotal}</span>
                    </div>
<div className="mb-8 d-flex justify-content-between">
  <span className=" text-xl">Delivery Fee</span>
  <span className=" text-dark">₹{deliveryFee}</span>
</div>

                   <div className="mb-8 d-flex justify-content-between">
  <span className=" text-xl">GST (5%)</span>
  <span className=" text-dark">₹{gstAmount.toFixed(2)}</span>
</div>


                    <div className="d-flex justify-content-between">
                      <span className="fw-semibold text-xl">Total</span>
                      <span className="fw-bold text-dark">₹{totalAmount}</span>
                    </div>
                  </div>
                </div>

                {/* PAYMENT */}
                {/* <div className="mt-32 payment-wrapper"> */}
                {/* UPI */}
                {/* <div
                    className={`payment-item ${
                      selectedPayment === "upi" ? "active" : ""
                    }`}
                  >
                    <label className="payment-box">
                      <input
                        type="radio"
                        name="payment"
                        checked={selectedPayment === "upi"}
                        onChange={() => setSelectedPayment("upi")}
                      />
                      <div className="payment-content">
                        <span className="payment-title">UPI Payment</span>
                        <span className="payment-desc">
                          Pay using Google Pay, PhonePe, Paytm, BHIM UPI
                        </span>
                      </div>
                    </label>
                  </div> */}

                {/* UPI Apps */}
                {/* {selectedPayment === "upi" && (
                    <div className="upi-apps mt-3">
                      <h6 className="text-lg mb-3">Select UPI App</h6>
                      <div className="row gy-2">
                        <div className="col-6">
                          <button
                            type="button"
                            className={`btn w-100 ${
                              selectedUPIApp === "gpay" ? "btn-primary" : "btn-outline-primary"
                            }`}
                            onClick={() => setSelectedUPIApp("gpay")}
                          >
                            Google Pay
                          </button>
                        </div>
                        <div className="col-6">
                          <button
                            type="button"
                            className={`btn w-100 ${
                              selectedUPIApp === "phonepe" ? "btn-primary" : "btn-outline-primary"
                            }`}
                            onClick={() => setSelectedUPIApp("phonepe")}
                          >
                            PhonePe
                          </button>
                        </div>
                        <div className="col-6">
                          <button
                            type="button"
                            className={`btn w-100 ${
                              selectedUPIApp === "paytm" ? "btn-primary" : "btn-outline-primary"
                            }`}
                            onClick={() => setSelectedUPIApp("paytm")}
                          >
                            Paytm
                          </button>
                        </div>
                        <div className="col-6">
                          <button
                            type="button"
                            className={`btn w-100 ${
                              selectedUPIApp === "bhim" ? "btn-primary" : "btn-outline-primary"
                            }`}
                            onClick={() => setSelectedUPIApp("bhim")}
                          >
                            BHIM UPI 
                          </button>
                        </div>
                      </div>
                    </div>
                  )} */}

                {/* Debit Card */}
                {/* <div
                    className={`payment-item ${
                      selectedPayment === "debit" ? "active" : ""
                    }`}
                  >
                    <label className="payment-box">
                      <input
                        type="radio"
                        name="payment"
                        checked={selectedPayment === "debit"}
                        onChange={() => setSelectedPayment("debit")}
                      />
                      <div className="payment-content">
                        <span className="payment-title">Debit Card</span>
                        <span className="payment-desc">
                          Pay using Debit Card
                        </span>
                      </div>
                    </label>
                  </div> */}

                {/* Card Form */}
                {/* {selectedPayment === "debit" && (
                    <div className="card-form mt-3">
                      <h6 className="text-lg mb-3">Enter Card Details</h6>
                      <div className="row gy-3">
                        <div className="col-12">
                          <input
                            type="text"
                            className="common-input border-gray-100"
                            placeholder="Card Number"
                            value={cardDetails.cardNumber}
                            onChange={handleCardChange}
                            name="cardNumber"
                            required
                          />
                          {cardErrors.cardNumber && <small className="text-danger">{cardErrors.cardNumber}</small>}
                        </div>
                        <div className="col-6">
                          <input
                            type="text"
                            className="common-input border-gray-100"
                            placeholder="Expiry (MM/YY)"
                            value={cardDetails.expiry}
                            onChange={handleCardChange}
                            name="expiry"
                            required
                          />
                          {cardErrors.expiry && <small className="text-danger">{cardErrors.expiry}</small>}
                        </div>
                        <div className="col-6">
                          <input
                            type="text"
                            className="common-input border-gray-100"
                            placeholder="CVV"
                            value={cardDetails.cvv}
                            onChange={(e) => setCardDetails({ ...cardDetails, cvv: e.target.value })}
                            required
                          />
                        </div>
                        <div className="col-12">
                          <input
                            type="text"
                            className="common-input border-gray-100"
                            placeholder="Cardholder Name"
                            value={cardDetails.name}
                            onChange={handleCardChange}
                            name="name"
                            required
                          />
                          {cardErrors.name && <small className="text-danger">{cardErrors.name}</small>}
                        </div>
                      </div>
                    </div>
                  )} */}

                {/* COD */}
                {/* <div
                    className={`payment-item ${
                      selectedPayment === "cod" ? "active" : ""
                    }`}
                  >
                    <label className="payment-box">
                      <input
                        type="radio"
                        name="payment"
                        checked={selectedPayment === "cod"}
                        onChange={() => setSelectedPayment("cod")}
                      />
                      <div className="payment-content">
                        <span className="payment-title">Cash on Delivery</span>
                        <span className="payment-desc">
                          Pay when your order is delivered
                        </span>
                      </div>
                    </label>
                  </div> */}

                {/* Commented out payment gateways for future implementation */}
                {/*
                  <div className="payment-item">
                    <label className="payment-box">
                      <input type="radio" name="payment" />
                      <div className="payment-content">
                        <span className="payment-title">Google Pay</span>
                        <span className="payment-desc">
                          Pay using Google Pay
                        </span>
                      </div>
                    </label>
                  </div>

                  <div className="payment-item">
                    <label className="payment-box">
                      <input type="radio" name="payment" />
                      <div className="payment-content">
                        <span className="payment-title">PhonePe</span>
                        <span className="payment-desc">
                          Pay using PhonePe
                        </span>
                      </div>
                    </label>
                  </div>

                  <div className="payment-item">
                    <label className="payment-box">
                      <input type="radio" name="payment" />
                      <div className="payment-content">
                        <span className="payment-title">Paytm</span>
                        <span className="payment-desc">
                          Pay using Paytm
                        </span>
                      </div>
                    </label>
                  </div>

                  <div className="payment-item">
                    <label className="payment-box">
                      <input type="radio" name="payment" />
                      <div className="payment-content">
                        <span className="payment-title">Credit Card</span>
                        <span className="payment-desc">
                          Pay using Credit Card
                        </span>
                      </div>
                    </label>
                  </div>

                  <div className="payment-item">
                    <label className="payment-box">
                      <input type="radio" name="payment" />
                      <div className="payment-content">
                        <span className="payment-title">Debit Card</span>
                        <span className="payment-desc">
                          Pay using Debit Card
                        </span>
                      </div>
                    </label>
                  </div>
                  */}
                {/* </div> */}

                {/* PRIVACY */}
                <div className="mt-32 pt-32">
                  <p className="text-gray-500 text-sm">
                    Your personal data will be used to process your order and
                    support your experience. Read our{" "}
                    <a
                      href="#"
                      className="text-main-600 text-decoration-underline"
                    >
                      privacy policy
                    </a>
                    .
                  </p>
                </div>
                {/* <button
                  className="add-cart-btn bg-primary1 mt-24"
                  onClick={handlePlaceOrder}
                >
                  Place Order
                </button> */}

                {/* BUTTON */}
                <button
                  className="add-cart-btn bg-primary1 mt-24"
                  onClick={razorpay}
                >
                  Place Order
                </button>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default Checkout;
